import { render, staticRenderFns } from "./ImagePage.vue?vue&type=template&id=26656164&scoped=true&"
import script from "./ImagePage.vue?vue&type=script&lang=ts&"
export * from "./ImagePage.vue?vue&type=script&lang=ts&"
import style0 from "./ImagePage.vue?vue&type=style&index=0&id=26656164&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26656164",
  null
  
)

export default component.exports